var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.57539 11.2094H8.82539L9.72539 7.60938H6.57539V5.80937C6.57539 4.88237 6.57539 4.00937 8.37539 4.00937H9.72539V0.985375C9.43199 0.946675 8.32409 0.859375 7.15409 0.859375C4.71059 0.859375 2.97539 2.35067 2.97539 5.08937V7.60938H0.275391V11.2094H2.97539V18.8594H6.57539V11.2094Z","fill":"#B7BAC1"}));
}

IconFacebook.defaultProps = {"width":"10","height":"19","viewBox":"0 0 10 19","fill":"none"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
